import styled from 'react-emotion';
/**
 * displays abolutely positioned transparent cover.
 * <Opacity active={disabled} density={0.7}><Loader small /></Opacity>
*/
const Opacity = styled("div")`
  display: none;
  ${props => props.active ? `
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(${props.color || '255, 255, 255'}, ${props.density || 0.85});
    justify-content: center;
    align-items: center;
    display: flex;
    z-index: 3;
    h1 {
      font-size: 16px;
      font-weight: 600;
      text-align: center;
    }
  ` : null}
`;

export default Opacity;


// WEBPACK FOOTER //
// ./src/components/ui/Opacity.jsx